export const OPTION_SEARCH = 'search'
export const OPTION_INPUT = 'input'
export const OPTION_TEXTAREA = 'textarea'


export const options = [
  {key:'contact_first_name', label:'Förnamn', value:'', type:OPTION_INPUT},
  {key:'contact_last_name', label:'Efternamn', value:'', type:OPTION_INPUT},
  {key:'contact_organisation', label:'Orgnisation', value:'', type:OPTION_INPUT},
  {key:'contact_unit', label:'Avdelning', value:'', type:OPTION_INPUT},
  {key:'contact_address', label:'Adress', value:'', type:OPTION_INPUT},
  {key:'contact_zip', label:'Postnummer', value:'', type:OPTION_INPUT},
  {key:'contact_city', label:'Stad', value:'', type:OPTION_INPUT},
  {key:'contact_country', label:'Land', value:'', type:OPTION_INPUT},
  {key:'contact_mob', label:'Mobil-nummer', value:'', type:OPTION_INPUT},
  {key:'contact_tel', label:'Telefonnummer', value:'', type:OPTION_INPUT},
  {key:'contact_mail', label:'E-post', value:'', type:OPTION_INPUT},
  {key:'contact_www', label:'Hemsida', value:'', type:OPTION_INPUT},
  {key:'contact_more_info', label:'Presentation', value:'', type:OPTION_INPUT},
  {key:'contact_org_type', label:'Organisationstyp', value:'', type:OPTION_INPUT},
  // {key:'contact_smf', label:''},
  // {key:'contact_umf', label:''},
  // {key:'contact_smfnet', label:''},
  // {key:'contact_created', label:''},
  // {key:'contact_created_by', label:''},
  // {key:'contact_changed', label:''},
  // {key:'contact_changed_by', label:''},
  {key:'contact_keywords', label:'Sökord', value:'', type:OPTION_INPUT},
  // {key:'contact_newsletter', label:'Nyhetsbrev'},
  // {key:'contact_tags', label:'Taggar', value:'', type:'tag'},
  {key:'contact_internal_comments', label:'Interna kommentarer', value:'', type:OPTION_INPUT},
  // {key:'contact_uuid', label:''},
  // {key:'contact_aoi', label:''},
]
